export const environment = {
  production: false,
  api: {
    baseUrl: 'https://forms.development.jrs.gantabi.com/core/v1',
    endpoints: {
      sessions: '/sessions',
      users: '/users',
      accounts: '/accounts',
      countries: '/countries',
      partners: '/partners',
      beneficiaries: '/beneficiaries',
      forms: '/forms',
      surveys: '/surveys',
    },
  },
  features: {
    mockAuth: false,
    enableDebug: true,
  },
  // Apache Superset (embedded dashboard). El guestTokenEndpoint ya no se declara aquí:
  // se deriva de ApiEndpoints.superset.guestToken (core/config/superset.config.ts).
  superset: {
    domain: 'https://dashboard.oneclick.gantabi.com',
    dashboardId: '28872c6d-d4dd-44d7-a5e7-0a4f5e78219e',
  },
};
